// Helper types for React Query
type WithResponse<T> = T & { response: Response };
type ApiResult = Promise<WithResponse<{ data: any; error?: never } | { data?: never; error: any }>>;
type ApiCall = (...args: any[]) => ApiResult;
export type InferFetchData<TFunc extends ApiCall> = NonNullable<Awaited<ReturnType<TFunc>>['data']>;
export type InferFetchError<TFunc extends ApiCall> = NonNullable<Awaited<ReturnType<TFunc>>['error']>;

/**
 * Returns the data of the apiResult or throws the error of the apiResult so it's picked up by React Query
 * @param apiResult Response returned by apiClient
 * @returns Data of apiResult
 */
export async function throwOnError<TResult extends ApiResult>(apiResult: TResult): Promise<NonNullable<Awaited<TResult>['data']>> {
  const { data, error } = await apiResult;
  if (error != null) {
    throw error;
  }
  return data;
}

/**
 * This type shouldn't be necessary, but errors aren't always documented in the OpenAPI docs by backend.
 */
export type ApiError = {
  status: number;
  message: string | null;
  exception: {
    message: string;
    file: string;
    line: number;
    code: number;
    trace: string;
  };
};
